import {makeCnVariants, isFunction} from '../../../../helpers'
import {Layout} from '../../../layout'
import {InfoIconMessage} from '../../../info_icon_message'
import {useBasicTableContext} from '../../context'
import {BooleanCell, DateCell, Cell} from './cells'

const getCell = cell => {
	if (isFunction(cell)) return cell

	switch (cell) {
		case 'boolean':
			return BooleanCell
		case 'date':
			return DateCell
		default:
			return Cell
	}
}

export const BasicTableCell = ({item, column, itemIndex}) => {
	const {withBorders, ...rest} = useBasicTableContext()
	const classNames = makeCnVariants('basic-table-row-cell', withBorders && 'with-borders')
	const {cell, accessorKey, accessorFn, infoIconMessageFn, style} = column
	const value = accessorKey ? item[accessorKey] : accessorFn(item, itemIndex)

	const Cell = getCell(cell)
	const infoIconMessage = infoIconMessageFn?.(item, rest)

	return (
		<Layout height="full" style={style} padding="0 16" className={classNames} minHeight={40}>
			<Cell {...rest} column={column} item={item} value={value} />
			{infoIconMessage && <InfoIconMessage {...infoIconMessage} />}
		</Layout>
	)
}
